import { IconButton, Box, AppBar, Toolbar, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { AvatarHeader } from "../sharedComponents/AvatarEditor";
import { useTheme } from "../../styles/editor/ThemeContextEditor";
import { useAuth } from "../../context/AuthContext";
import ThemeToggleButton from "../../styles/editor/ThemeToggleEditor";

export const HeaderEditor = ({ handleMenuToggle, nameDocument }) => {
  const { colors } = useTheme();
  const { user } = useAuth();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: "transparent",
        borderBottom: `1px solid ${colors.border.primary}`,
        py: { xs: 1, sm: 2 },
        px: { xs: 1.5, sm: 4 },
        position: "relative",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 0,
          minHeight: "auto",
          gap: { xs: 0.5, sm: 2 },
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
            gap: { xs: 1, sm: 2 },
          }}
        >
          <IconButton
            onClick={handleMenuToggle}
            size="small"
            sx={{
              color: colors.text.primary,
              "&:hover": {
                backgroundColor: colors.background.cardHover,
              },
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            pointerEvents: "none",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 900,
              letterSpacing: 0.4,
              color: colors.text.primary,
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              fontSize: { xs: "0.9rem", sm: "1.6rem" },
            }}
          >
            {nameDocument || "Sin nombre"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.5, sm: 1 },
            flexShrink: 0,
            ml: "auto",
          }}
        >
          <ThemeToggleButton
            position="relative"
            sx={{
              transform: { xs: "scale(0.9)", sm: "scale(1)" },
            }}
          />
          <AvatarHeader
            userMe={user}
            sx={{
              width: { xs: 28, sm: 36 },
              height: { xs: 28, sm: 36 },
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};
